import { ApolloQueryResult } from '@apollo/client';
import {
  OxfordSuggestionsDocument,
  OxfordSuggestionsQuery,
  OxfordSuggestionsQueryVariables,
} from '@replacements/graphql/replacementsDictionary/operation.generated';
import useImperativeQuery from 'lib/useImperativeQuery';

export type LoadOxfordSuggestionsFn = (
  variables?: Partial<OxfordSuggestionsQueryVariables>
) => Promise<ApolloQueryResult<OxfordSuggestionsQuery>>;

// todo: actually update cache...
const useLazyOxfordSuggestions = (word: string) => {
  return useImperativeQuery<
    OxfordSuggestionsQuery,
    OxfordSuggestionsQueryVariables
  >(OxfordSuggestionsDocument, {
    variables: {
      inputs: {
        word,
      },
    },
    fetchPolicy: 'cache-and-network',
  });
};

export default useLazyOxfordSuggestions;
